import { Component, ElementRef, Renderer2, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  FormControl,
  AbstractControl,
  FormArray,
} from "@angular/forms";
import { InventoryService } from "src/app/service/inventory.service";
import { MatInputModule } from "@angular/material/input";
import { MatSelect, MatSelectChange, MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgClass } from "@angular/common";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatOptionSelectionChange, provideNativeDateAdapter } from "@angular/material/core";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {
  MatAutocomplete,
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  
} from "@angular/material/autocomplete";
import { MatIcon } from "@angular/material/icon";
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { NgxSonnerToaster, toast } from "ngx-sonner";
import { NoDataComponent } from "../shared/no-data/no-data.component";
import { CrmService } from "src/app/service/crm.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { alertModalDecline, alertModalDelete, alertModalWithoutConfirm, alertModalWithoutConfirmMsg } from "../../helpers/alert";
import { environment } from "src/environments/environment";
// import { NotificationService } from "src/app/service/notification.service";

interface Cycle {
  value: string;
  viewValue: string;
}
interface Urgency {
  value: string;
  viewValue: string;
}
interface Type {
  value: string;
  viewValue: string;
}

interface AllInventoryReq {
  value: string;
  viewValue: string;
}
interface PendingInventoryReq {
  value: string;
  viewValue: string;
}
interface ApprovedInventoryReq {
  value: string;
  viewValue: string;
}

interface DeclinedInventorysReq {
  value: string;
  viewValue: string;
}
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { INVENTORY_APPROVER_DEPARTMENTS, isHrOrItAdminDept } from 'src/app/constants/departments';
@Component({
    selector: "app-inventory-request",
    providers: [provideNativeDateAdapter()],
    imports: [
        MatInputModule,
        MatSelectModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatAutocomplete,
        MatAutocompleteModule,
        NgClass,
        FormsModule,
        MatDatepickerModule,
        NgxSonnerToaster,
        NoDataComponent,
        InfiniteScrollModule,
        MatCheckboxModule,
        MatIcon,
        MatChipsModule,
    ],
    templateUrl: "./inventory-request.component.html",
    styleUrls: ["./inventory-request.component.css", "../styles/inventory.css"]
})
export class InventoryRequestComponent {
  /** HR, HR-HEAD, or IT-ADMIN: the same buttons and approver lists. */
  get isHrUser(): boolean {
    return isHrOrItAdminDept(this.userDepartment);
  }

  @ViewChild('auto') auto: MatAutocomplete;
   @ViewChild('autoPanel') autoComplete: ElementRef | undefined;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
 @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

 
  showInventoryRequest: boolean = true;
  showPendingRequest: boolean = false;
  showApprovedRequest: boolean = false;
  showDeclinedRequest: boolean = false;
  showForwardButton = false;
  inventoryRequestForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private inventoryService: InventoryService,
    private crmService: CrmService,
    private renderer: Renderer2,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.inventoryRequestForm = this.fb.group({
      projectName: ["",  [Validators.required, Validators.maxLength(100),,this.noWhitespaceValidator]],
      urgency: ["", Validators.required],
      approverName: ["", Validators.required],
      projectLocation: ["",  [Validators.required, Validators.maxLength(50),,this.noWhitespaceValidator]],
      requestType: ["", Validators.required],
      assets: this.fb.array([], Validators.required) 
    });
  }


  createAssetFormGroup(asset?: any) {
  return this.fb.group({
    assetId: [asset?.assetId || '', Validators.required],
    quantity: [asset?.quantity || 1, [Validators.required, Validators.min(1)]],
    startDate: [asset?.startDate || '', Validators.required],
    endDate: [asset?.endDate || '', Validators.required],
    viewValue: [asset?.viewValue || ''] 
  });
}

get assetsFormArray() {
  return this.inventoryRequestForm.get('assets') as FormArray;
}


    //shimmer loader
    isShimmerLoading: boolean = true;
    shimmerLoadingValue = ([] = [1, 2, 3, 4]);


  submitted = false;
  userDepartment: string ;
  productIdFromQuery: string ;
  today: string;
  loggedUserId: any;
  filteredInventory: any[] = [];

  ngOnInit() {

    this.selectedInventoryControl.valueChanges.subscribe((value) => {
    this.filterInventory(value);
    });


     setTimeout(() => this.attachScrollListener(), 1000);
    // this.getAllUsers();
    this.getInventoryData();
    this.getInventoryRequest();
    this.getApproverUsersList();
    this.loggedUserId = localStorage.getItem("guestID")
    this.userDepartment = localStorage.getItem("department");
    this.showForwardButton = isHrOrItAdminDept(this.userDepartment);

    const now = new Date();
    this.today = now.toISOString().split("T")[0];

  
    this.route.queryParams.subscribe((params) => {
      if (params['productId']) {
        this.productIdFromQuery = params['productId'];
        this.inventoryRequestForm.patchValue({
          selectedInventory: this.productIdFromQuery,
        });
    
        console.log("All inventories:",this.inventory);
    
        setTimeout(() => {
          const existingInventory = this.inventory.find(
            (item) => item.viewValue === this.productIdFromQuery
          );
        
          console.log('Did you find?', existingInventory);
        
          if (existingInventory) {
            console.log('Existing Inventory:', existingInventory);
            console.log('Existing Inventory AssetId:', existingInventory.assetId);
        
            this.inventory = [
              existingInventory,
              ...this.inventory.filter((item) => item.viewValue !== this.productIdFromQuery),
            ];
        
            this.onInventoryChange({
              option: { value: existingInventory },
            } as MatAutocompleteSelectedEvent);
        
            this.inventoryRequestForm.patchValue({
              assetId: existingInventory.assetId,
            });
        
            console.log('After patching assetId:', this.inventoryRequestForm.value.assetId);
          } else {
            console.warn('Inventory not found for productId:', this.productIdFromQuery);
          }
        
          this.auto.options.first?.select();
          this.selectedInventoryControl.setValue({
            viewValue: this.productIdFromQuery,
          });
        }, 1000);
        
      }
    
      if (params['openInventoryReq'] === 'true') {
        this.openInventoryRequestModal();;
      }
    }); 

    this.route.queryParams.subscribe(params => {
      const filter = params['filter'];
      if (filter) {
        this.selectedFilter = filter; 
        this.applyFilterFromQuery(filter);
      }
    });
  }

  filterInventory(value: string | any) {
     if (!this.inventory?.length) return;
  const filterValue =
    typeof value === 'string' ? value.toLowerCase() : value?.viewValue?.toLowerCase();

  if (!filterValue) {
    this.filteredInventory = this.inventory;
    return;
  }

  this.filteredInventory = this.inventory.filter((inv) =>
    inv.viewValue.toLowerCase().includes(filterValue)
  );
  // console.log('Filtered Inventory:', this.filteredInventory);
}

selectedInventories: any[] = [];

toggleInventorySelection(inv: any) {
  if (!inv || !inv.assetId) return;

  const index = this.selectedInventories.findIndex(i => i.assetId === inv.assetId);

  if (index >= 0) {
    this.selectedInventories.splice(index, 1);
  } else {
    this.selectedInventories.push({
      ...inv,
      selectedQuantity: inv.selectedQuantity || 1,
      maxQuantity: inv.quantity
    });
  }

  this.updateFormAssets();
  this.searchQuery = '';
  this.selectedInventoryControl.setValue('');
}



handleOptionSelection(inv: any, event: any) {
  if (event.isUserInput) {
    this.toggleInventorySelection(inv);
    event.source.deselect();
  }
}

updateQuantityFromOption(inv: any, quantity: number) {
  const existing = this.selectedInventories.find(i => i.assetId === inv.assetId);

  if (existing) {
    existing.selectedQuantity = quantity || 1; 
  } else {
    this.selectedInventories.push({
      ...inv,
      selectedQuantity: quantity || 1,
      maxQuantity: inv.quantity
    });
  }

  // Update FormArray too
  const formIndex = this.assetsFormArray.controls.findIndex(
    control => control.get('assetId')?.value === inv.assetId
  );

  if (formIndex > -1) {
    this.assetsFormArray.at(formIndex).patchValue({ quantity: quantity || 1 });
  }

  this.updateFormAssets();
}


private updateFormAssets() {
    const assetsArray = this.inventoryRequestForm.get('assets') as FormArray;

    while (assetsArray.length > this.selectedInventories.length) {
        assetsArray.removeAt(assetsArray.length - 1);
    }

    this.selectedInventories.forEach((inv, index) => {
        const existingGroup = assetsArray.at(index);

        const formValue = {
            assetId: inv.assetId,
            quantity: inv.selectedQuantity || 1,
            startDate: inv.startDate || this.inventoryDates[inv.assetId]?.startDate || '',
            endDate: inv.endDate || this.inventoryDates[inv.assetId]?.endDate || '',
            viewValue: inv.viewValue || ''
        };

        if (!existingGroup) {
            assetsArray.push(this.createAssetFormGroup(formValue));
        } else {
            existingGroup.patchValue(formValue);
        }
    });
}







getQuantityArray(count: number): number[] {
  return Array.from({ length: count }, (_, i) => i + 1);
}

prepareInventoryData(data: any[]) {
  return data.map(inv => ({
    ...inv,
    quantityOptions: this.getQuantityArray(inv.quantity)
  }));
}


isSelected(inv: any): boolean {
  return this.selectedInventories.some(i => i.assetId === inv.assetId);
}

@ViewChild('quantitySelect') quantitySelect: MatSelect;
removeInventory(item: any) {
  const index = this.selectedInventories.findIndex(i => i.assetId === item.assetId);
  if (index > -1) {
    this.selectedInventories.splice(index, 1);
  }

  const formIndex = this.assetsFormArray.controls.findIndex(
    control => control.get('assetId')?.value === item.assetId
  );
  if (formIndex > -1) {
    this.assetsFormArray.removeAt(formIndex);
  }

  const target = this.inventory.find(inv => inv.assetId === item.assetId);
  if (target) {
    target.selectedQuantity = null;
    target.startDate = null;
    target.endDate = null;
  }

  this.filteredInventory = [...this.inventory];
  this.searchQuery = '';
  this.inventoryRequestForm.get('assets')?.updateValueAndValidity();

  setTimeout(() => {
    if (this.quantitySelect) {
      this.quantitySelect.close();
      this.quantitySelect.writeValue(null);
    }
  });
}






  
onAutoCompleteOpened() {
  setTimeout(() => {
    if (this.matAutocomplete && this.matAutocomplete._keyManager) {
      this.matAutocomplete._keyManager.setActiveItem(-1);
    }

    this.attachScrollListener();
  }, 300);
}

onOptionSelectionChange(inventory: any, event: any) {
  const isChecked =
    event instanceof MatCheckboxChange
      ? event.checked
      : event.source?.selected;

  if (isChecked) {
    this.selectedInventories.push(inventory);
  } else {
    this.selectedInventories = this.selectedInventories.filter(
      (i) => i.assetId !== inventory.assetId
    );
  }
}


addInventoryToSelected(inv: any) {
  if (this.selectedInventories.length >= 10) {
    alertModalWithoutConfirm('warning', 'You cannot select more than 10 assets.');
    return;
  }
  if (!this.isSelected(inv)) {
    this.selectedInventories.push({
      ...inv,
      selectedQuantity: inv.selectedQuantity || 1,
    });
  }
}


isLoadingMore: boolean = false;
attachScrollListener() {
  const panel = document.querySelector('.mat-autocomplete-panel');
  if (panel && !panel.getAttribute('listener-attached')) {
    panel.setAttribute('listener-attached', 'true');

    panel.addEventListener('scroll', () => {
      const threshold = 100; // px before bottom
      if (
        panel.scrollTop + panel.clientHeight >= panel.scrollHeight - threshold &&
        !this.isLoadingMore &&
        this.inventory.length < this.currentLimit
      ) {
        this.getInventoryData();
      }
    });
  }
}

  selectedFilter: string = '';
  applyFilterFromQuery(displayFilter: string) {
    const filterValue = this.filterTypeMap[displayFilter];
    this.selectedFilter = displayFilter; 
    switch (displayFilter) {
      case 'Approved Request':
        this.onFilterApprovedRequest(filterValue);
        break;
      case 'Declined Request':
      case 'Rejected':
        this.onFilterDeclinedRequest(filterValue);
        break;
      default:
        console.warn('Unknown filter:', displayFilter);
    }
  }
  
  
  filterTypeMap: Record<string, string> = {
    'Approved Request': 'Inventory Request',
    'Pending Request': 'Inventory Request',
    'Declined Request': 'Rejected',
  };


  openInventoryRequestModal(){
    const modalElement = document.getElementById("inventoryRequestModal");
    if (modalElement) {
      this.renderer.addClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "block");
    }
  }

  closeInventoryRequestModal() {
    const modalElement = document.getElementById("inventoryRequestModal");
    const backdrop = document.querySelector(".modal-backdrop");
  
    if (modalElement) {
      this.renderer.removeClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "none");
      this.renderer.setAttribute(modalElement, "aria-hidden", "true");
      this.renderer.removeClass(document.body, "modal-open");
      this.renderer.setStyle(document.body, "paddingRight", ""); 
    }
  
    if (backdrop) {
      this.renderer.removeChild(document.body, backdrop);
    }
  
    this.router.navigate(['/inventory/inventory-request']);
  }
  



  allInventoryReq: AllInventoryReq[] = [
    { value: "Inventory Request", viewValue: "Inventory Request" },
  ];

  pendingInventoryReq: PendingInventoryReq[] = [
    { value: "Inventory Request", viewValue: "Pending Request" },
  ];
  approvedInventoryReq: ApprovedInventoryReq[] = [
    { value: "Inventory Request", viewValue: "Approved Request" },
  ];

  declinedInventoryReq: DeclinedInventorysReq[] = [
    { value: "Rejected", viewValue: "Declined Request" },
  ];

  // Reset Form
  openInventoryRequest() {
    this.inventoryRequestForm.reset();
    this.formSubmitted = false;
    this.submitted = false; 
    this.selectedInventories = [];   
    this.selectedInventoryControl.reset();
    this.searchQuery = ''; 
  }
  
  handleCheckboxClick(event: MouseEvent, inventories: any) {
  event.stopPropagation();
  this.toggleInventorySelection(inventories);
}

handleCheckboxChange(event: any, inv: any) {
  if (event.checked) {
    const exists = this.selectedInventories.find(i => i.assetId === inv.assetId);
    if (!exists) {
      this.selectedInventories.push({
        ...inv,
        selectedQuantity: inv.selectedQuantity || null,
        maxQuantity: inv.quantity
      });
    }
  } else {
    this.selectedInventories = this.selectedInventories.filter(i => i.assetId !== inv.assetId);
  }

  this.updateFormAssets();

  // ✅ Clear search AFTER this tick, avoids "top item also selected"
  setTimeout(() => {
    this.searchQuery = '';
    this.selectedInventoryControl.setValue('');
  });
}


handleContentClick(event: MouseEvent, inventories: any) {
  if (!(event.target as Element).closest('.dropdown-area')) {
    this.toggleInventorySelection(inventories);
  }
  event.stopPropagation();
}

  // Select Fields
  cycles: Cycle[] = [
    { value: "days", viewValue: "Days" },
    { value: "weeks", viewValue: "Weeks" },
    { value: "months", viewValue: "Months" },
    { value: "years", viewValue: "Years" },
  ];

  urgencies: Urgency[] = [
    { value: "High", viewValue: "High" },
    { value: "Medium", viewValue: "Medium" },
    { value: "Low", viewValue: "Low" },
  ];

  types: Type[] = [
    { value: "For-Demo", viewValue: "For Demo" },
    { value: "Personal-Use", viewValue: "Personal Use" },
  ];

  //Request For - Dropdown
  numbers: number[] = Array.from({ length: 100 }, (_, i) => i + 1);


  noWhitespaceValidator(control: AbstractControl): { [key: string]: any } | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }
  

  //Listing of Users in Dropdown
  users: { value: string; viewValue: string; id: string }[] = [];
  getAllUsers(): void {
    this.inventoryService.getInvUsers().subscribe((res) => {
      let data = res["data"];
      this.users = data.map((user: any) => ({
        value: user.userName,
        viewValue: user.userName,
        id: user._id,
      }));
      console.log("users", this.users);
    });
  }

// Approver Users (ADMIN, IT-ADMIN, HR-HEAD, HR)
approverUsers: { value: string; viewValue: string; id: string; department?: string }[] = [];
adminUsers: { value: string; viewValue: string; id: string }[] = [];
hrUsers: { value: string; viewValue: string; id: string }[] = [];
approvers: { value: string; viewValue: string; id: string }[] = [];

loggedInUsername = localStorage.getItem("username") || '';
loggedInUserId = localStorage.getItem("guestID") || '';

getApproverUsersList(): void {
  const approverDepts = INVENTORY_APPROVER_DEPARTMENTS;
  forkJoin(
    approverDepts.map((dept) =>
      this.crmService.getAnyUsers(dept).pipe(
        catchError((err) => {
          console.error(`Error fetching approvers for department ${dept}:`, err);
          return of({ data: [] });
        })
      )
    )
  ).subscribe((results: any[]) => {
    const userMap = new Map<string, { value: string; viewValue: string; id: string; department?: string }>();

    results.forEach((res, index) => {
      const expectedDept = approverDepts[index];
      const rawList = res?.data || res?.records || (Array.isArray(res) ? res : []);
      if (Array.isArray(rawList)) {
        rawList.forEach((user: any) => {
          const id = user?._id || user?.id;
          const userName = (user?.userName || user?.name || '').trim();
          const userDept = user?.department ? String(user.department).trim().toUpperCase() : expectedDept;
          if (id && userName && approverDepts.includes(userDept)) {
            if (!userMap.has(id)) {
              userMap.set(id, {
                value: userName,
                viewValue: userName,
                id: id,
                department: userDept,
              });
            }
          }
        });
      }
    });

    const sortedUsers = Array.from(userMap.values()).sort((a, b) =>
      a.viewValue.localeCompare(b.viewValue, undefined, { sensitivity: 'base' })
    );

    this.approverUsers = sortedUsers;
    this.adminUsers = sortedUsers;
    this.hrUsers = sortedUsers;
    this.approvers = sortedUsers;
    console.log("Filtered approvers:", this.approverUsers);
  });
}

getAdminUsersList() {
  this.getApproverUsersList();
}

getHrUsersList() {
  this.getApproverUsersList();
}

mergeApproversIfNeeded() {
  this.approvers = this.approverUsers;
}


disableTyping(event: KeyboardEvent) {
    event.preventDefault();
}




  //On Select Asset field
selectedInventoryControl = new FormControl();
onInventoryChange(event: MatAutocompleteSelectedEvent) {
    const selectedInventory = event.option.value;
    this.selectedInventoryControl.setValue(selectedInventory);

    this.inventoryRequestForm.patchValue({
      selectedInventory: selectedInventory.viewValue,
      assetId: selectedInventory.assetId,
    });
    console.log("Selected Asset ID:", selectedInventory.assetId);

    // const assetId = selectedInventory ? selectedInventory.assetId : null;
    // this.inventoryRequestForm.patchValue({
    //   assetId: assetId,
    // });
}

  displayFn(inventory: any): string {
    return inventory && inventory.viewValue ? inventory.viewValue : "";
  }

  //Listing of All created Inventories in Dropdown
  inventory: any[] = [];
  totalRecords: number = 0;
getInventoryData(reset: boolean = false) {
  if (reset) {
    this.currentPageNume = 1;
    this.inventory = [];
  }

  const field: any = {
    pageNum: this.currentPageNume,
    limit: 500,
    available: true,
    searchQuery: this.searchQuery || ''
  };

  this.isLoadingMore = true;
  this.inventoryService.getAllInventory(field).subscribe(
    (response: any) => {
      this.totalRecords = response.data.totalCounts; 
      const newItems = response.data.records.map((item: any) => ({
        value: item.name,
        viewValue: item.name,
        images: item.images || [],
        assetId: item.assetId || null,
        quantity: item.quantity || 0,
        quantityOptions: this.getQuantityArray(item.quantity || 0) 
      }));

      this.inventory = [...this.inventory, ...newItems];
       this.filteredInventory = [...this.inventory];
       this.filterInventory(this.searchQuery);
      this.currentPageNume++;
      this.isLoadingMore = false;
    },
    (error) => {
      console.error('Error', error);
      this.isLoadingMore = false;
    }
  );
}


  searchedInventory = [];
  totalSearchedInv: any;
  searchQuery: string;
  onSearchInventory() {
    const field: any = {
      pageNum: 1,
      limit: 100,
      searchQuery: this.searchQuery,
    };

    if (this.searchQuery === "") {
      this.clearSearch();
    } else {
      this.inventoryService.getSearchedInventory(field).subscribe(
        (response: any) => {
          console.log(response);
          this.searchedInventory = response.data.records.map((item: any) => ({
            value: item.name,
            viewValue: item.name,
            images: item.images || [],
            assetId: item.assetId || null,
          }));
          console.log("Searched", this.searchedInventory);
          this.inventory = this.searchedInventory;
          this.totalSearchedInv = response.data.totalCounts;
        },
        (error) => {
          console.error("Error", error);
        }
      );
    }
  }

getSelectedQuantity(inventory: any): number | null {
  const selected = this.selectedInventories.find(i => i.assetId === inventory.assetId);
  return selected ? selected.selectedQuantity : null;
}

setSelectedQuantity(inventory: any, event: Event) {
  const value = +(event.target as HTMLSelectElement).value; 
  const finalQuantity = value > 0 ? value : 1;

  const inv = this.selectedInventories.find(i => i.assetId === inventory.assetId);
  if (inv) {
    inv.selectedQuantity = finalQuantity;
  }

  const formIndex = this.assetsFormArray.controls.findIndex(
    control => control.get('assetId')?.value === inventory.assetId
  );
  if (formIndex > -1) {
    this.assetsFormArray.at(formIndex).patchValue({
      quantity: finalQuantity
    });
  }

  this.updateChipLabels();
}


updateChipLabels() {
    this.selectedInventories = this.selectedInventories.map(inv => ({
        ...inv,
        viewValue: inv.selectedQuantity
            ? `${inv.originalName || inv.viewValue.split(' (')[0]} (${inv.selectedQuantity})`
            : inv.originalName || inv.viewValue,
        startDate: inv.startDate || '',
        endDate: inv.endDate || ''
    }));
}


inventoryDates: { [assetId: string]: { startDate: string; endDate: string } } = {};


onStartDateChange(inventory: any, event: any) {
    const value = event.target.value;
    this.inventoryDates[inventory.assetId] = {
        ...this.inventoryDates[inventory.assetId],
        startDate: value
    };

    const inv = this.selectedInventories.find(i => i.assetId === inventory.assetId);
    if (inv) inv.startDate = value;

    this.updateFormAssets();
}

onEndDateChange(inventory: any, event: any) {
    const value = event.target.value;
    this.inventoryDates[inventory.assetId] = {
        ...this.inventoryDates[inventory.assetId],
        endDate: value
    };

    const inv = this.selectedInventories.find(i => i.assetId === inventory.assetId);
    if (inv) inv.endDate = value;

    this.updateFormAssets();
}








  clearSearch() {
    this.searchQuery = "";
    this.getInventoryData();
  }

  //DATE Format
  formatStartDate(date: Date): { day: number; month: number; year: number } {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }

  // closeDropdownIfDatesSelected(inv: any) {
  //   if (inv.startDate && inv.endDate) {
  //     this.autocompleteTrigger.closePanel();
  //   }
  // }

closeDropdownIfDatesSelected(inventory: any) {
  const assetControl = this.assetsFormArray.controls.find(
    control => control.get('assetId').value === inventory.assetId
  );
  
  if (assetControl) {
    const startDate = assetControl.get('startDate').value;
    const endDate = assetControl.get('endDate').value;
    
    if (startDate && endDate) {
    }
  }
}


onCheckboxSelectionChange(inventory: any, event: any) {
    const existing = this.selectedInventories.find(i => i.assetId === inventory.assetId);

    if (event.checked) {
        if (!existing) {
            this.selectedInventories.push({
                ...inventory,
                originalName: inventory.viewValue,
                selectedQuantity: 1,
                maxQuantity: inventory.quantity,
                startDate: this.inventoryDates[inventory.assetId]?.startDate || '',
                endDate: this.inventoryDates[inventory.assetId]?.endDate || ''
            });
        }
    } else {
        const index = this.selectedInventories.findIndex(
            item => item.assetId === inventory.assetId
        );
        if (index > -1) {
            this.selectedInventories.splice(index, 1);
        }
    }

    this.updateChipLabels();
    this.updateFormAssets();
}








  // Inventory Request Form Submit
  formSubmitted = false;
  isSubmitting: boolean = false;
onSubmitForm() {
  console.log(this.inventoryRequestForm.value);
   console.log('Assets array:', this.assetsFormArray.value);
  this.submitted = true;

  if (this.inventoryRequestForm.invalid) {
    console.log("Form is invalid");
    return alertModalWithoutConfirm(
      "warning",
      "Please fill in all required fields before submitting."
    );
  }

  if (this.selectedInventories.length > 10) {
    return alertModalWithoutConfirm(
      "warning",
      "You cannot select more than 10 assets."
    );
  }

  if (this.isSubmitting) {
    return;
  }
  this.isSubmitting = true;

  const inventoryValues = {
    ...this.inventoryRequestForm.value,
  };

  const startDate = new Date(inventoryValues.startDate);
  const formattedStartDate = this.formatStartDate(startDate);

  const endDate = new Date(inventoryValues.endDate);
  const formattedEndDate = this.formatStartDate(endDate);

   if (startDate > endDate) {
    this.isSubmitting = false; 
    return alertModalWithoutConfirm(
      "warning",
      "Start Date cannot be greater than End Date."
    );
  }


  const approver = (this.approverUsers && this.approverUsers.length > 0 ? this.approverUsers : [...this.adminUsers, ...this.hrUsers]).find(
    (user) => user.value === inventoryValues.approverName
  );
  console.log("approver:", approver);
  const approverId = approver ? approver.id : null;
  console.log({ approverId });

 const getInventoryFormValue: any = {
  ...this.inventoryRequestForm.value,
  approverId: approverId,
   redirectUrl: `${environment.redirectUrl}#/inventory/inventory-request`,
  assets: this.inventoryRequestForm.value.assets.map(asset => ({
    assetId: asset.assetId,
    quantity: asset.quantity,
    startDate: {
      day: new Date(asset.startDate).getDate(),
      month: new Date(asset.startDate).getMonth() + 1,
      year: new Date(asset.startDate).getFullYear()
    },
    endDate: {
      day: new Date(asset.endDate).getDate(),
      month: new Date(asset.endDate).getMonth() + 1,
      year: new Date(asset.endDate).getFullYear()
    }
  }))
};


  this.inventoryService.addInventoryRequest(getInventoryFormValue).subscribe(
    (response) => {
      console.log("submitted ", response);
      this.formSubmitted = true;
      this.isSubmitting = false;
      // window.location.reload();
      this.currentPageNume = 1;
      this.getInventoryRequest();
    },
(error) => {
  console.log("Error", error);
  this.isSubmitting = false;

  const nestedMessage = error?.error?.message?.message;
  const errorData = error?.error?.message?.errorData;

  if (
    nestedMessage?.toLowerCase().includes("inventory request limit exceeded")
  ) {
    alertModalWithoutConfirm("warning", "Inventory Request Limit Exceeded!");
  } else if (
    nestedMessage
      ?.toLowerCase()
      .includes("user cannot request the same product twice")
  ) {
    alertModalWithoutConfirm(
      "warning",
      "You have already requested this product."
    );
  } else if (Array.isArray(errorData) && errorData.length > 0) {
    errorData.forEach((err: any) => {
      const asset = err.unavailableAsset;
      const msg = `
        ${err.message}<br>
        Requested: ${asset.requested}, Available: ${asset.availableQuantity}<br>
        Next available from: ${asset.nextAvailableDate || "N/A"}
      `;
      alertModalWithoutConfirmMsg("error", msg);
    });
} else if (errorData && typeof errorData === "object") {
  let combinedMsg = "";

  if (errorData.requestLimitExceeded) {
    combinedMsg += `${errorData.requestLimitExceeded}<br>`;
  }

  if (Array.isArray(errorData.rentalAssetError) && errorData.rentalAssetError.length > 0) {
    errorData.rentalAssetError.forEach((err: any) => {
      combinedMsg += `
        ${err.message}<br>
        Asset: ${err.assetName}<br>
        Last Available Date: ${err.lastAvailableDate}<br>
      `;
    });
  }

  if (errorData.dateError) {
    combinedMsg += `${errorData.dateError}<br>`;
  }

  if (Array.isArray(errorData.conflicts) && errorData.conflicts.length > 0) {
    errorData.conflicts.forEach((conflict: any) => {
      const asset = conflict.unavailableAsset;
      let lockedPeriodsMsg = "";

      if (asset.lockedPeriods && asset.lockedPeriods.length > 0) {
      lockedPeriodsMsg = asset.lockedPeriods
        .map(
          (lp: any) =>
            `<div style="font-size:18px;margin-top:4px;">
              Locked Till: ${lp.start} → ${lp.end} (Qty: ${lp.quantity})
            </div>`
        )
        .join("");
    }


      combinedMsg += `
        ${conflict.message}<br>
        Asset: ${asset.name}<br>
        Requested: ${asset.requested}, Available: ${asset.availableQuantity}<br>
        Next available from: ${asset.nextAvailableDate || "N/A"}<br>
        ${lockedPeriodsMsg}<br>
      `;
    });
  }

  if (combinedMsg) {
    alertModalWithoutConfirmMsg("error", combinedMsg);
  } else {
    // fallback
    const msg = Object.values(errorData).join("<br>");
    alertModalWithoutConfirm("error", msg);
  }
}

  else {
    alertModalWithoutConfirm(
      "error",
      "Something went wrong. Please try again."
    );
  }
}





  );
}

  pendingReq = [];
  totalPending: any;
currentPendingLimit = 1000
onFilterPendingRequest(
  requestType: string,
  pageNum = 1,  
  limit = this.currentPendingLimit
) {
  this.currentRequestType = requestType;

  if (pageNum === 1) {
    this.pendingReq = [];
  }

  const getPendingReqValue: any = {
    requestType: requestType,
    pageNum: pageNum,
    limit: limit,
  };

  this.inventoryService
    .getPendingRequest(getPendingReqValue)
    .subscribe((response) => {
      console.log("Pending Request");

      const newRecords = response["data"].records;

      if (pageNum === 1) {
        this.pendingReq = newRecords;
      } else {
        // ✅ prevent duplicates (based on requestId or id)
        const existingIds = new Set(this.pendingReq.map((item: any) => item.id || item.requestId));
        const uniqueRecords = newRecords.filter((item: any) => !existingIds.has(item.id || item.requestId));

        this.pendingReq = [...this.pendingReq, ...uniqueRecords];
      }

      this.totalPending = response["data"].totalCounts;
      this.showInventoryRequest = false;
      this.showApprovedRequest = false;
      this.showPendingRequest = true;
      this.isShimmerLoading = false;
      this.showDeclinedRequest = false;
    });
}


    pendingSearchQuery: any;
searchedPendingInventory = [];
totalPendingSearchedInv: any;
onSearchPendingInventory() {

  const getPendingReqValue: any = {
    requestType: "Inventory Request",
    searchQuery: this.pendingSearchQuery,
    pageNum: this.currentPageNume,
    limit: this.totalPending,
  };

  if (!this.pendingSearchQuery || this.pendingSearchQuery.trim() === "") {
    this.clearPendingSearch();
  } else {
    this.inventoryService
      .getPendingRequest(getPendingReqValue)
      .subscribe((response) => {
        console.log("Search Pending Response", response);
        this.searchedPendingInventory = response["data"].records;
        this.pendingReq = this.searchedPendingInventory;
        this.totalPendingSearchedInv = response["data"].totalCounts;
        this.totalPending = this.totalPendingSearchedInv;
      });
  }
}

  clearPendingSearch() {
  this.pendingSearchQuery = "";
  this.onFilterPendingRequest("Inventory Request", 1, this.currentPendingLimit);
}


totalApprovedSearchedInv: any;
searchedApprovedInventory = [];
approvedSearchQuery:any;
onSearchApprovedInventory() {
  this.currentPageNume = 1
  const getApprovedReqValue: any = {
    requestType: "Inventory Request",
    searchQuery: this.approvedSearchQuery,
    pageNum: this.currentPageNume,
    limit: this.totalApproved,
  };

  if(this.showForwardButton) {
    getApprovedReqValue.isAll = "true";
  }

  if (!this.approvedSearchQuery || this.approvedSearchQuery.trim() === "") {
    this.clearApprovedSearch(); 
  } else {
    this.inventoryService
      .getApprovedRequest(getApprovedReqValue)
      .subscribe((response) => {
        console.log("Search Approved Response", response);
        this.searchedApprovedInventory = response["data"].records;
        this.approveInv = this.searchedApprovedInventory;
        this.totalApprovedSearchedInv = response["data"].totalCounts;
        this.totalApproved = this.totalApprovedSearchedInv;
      });
  }
}


clearApprovedSearch() {
  this.approvedSearchQuery = "";
  this.onFilterApprovedRequest("Inventory Request", 1, this.currentApprovedLimit);
}

  approveInv = [];
  totalApproved: any;
  currentRequestType: string = "";
  currentApprovedLimit = 1000
onFilterApprovedRequest(
  requestType: string,
  pageNum = 1, 
  limit = this.currentApprovedLimit
) {
  this.currentRequestType = requestType;

  if (pageNum === 1) {
    this.approveInv = [];
  }

  const getApprovedReqValue: any = {
    requestType: requestType,
    pageNum: pageNum,
    limit: limit,
  };

  if (this.showForwardButton) {
    getApprovedReqValue.isAll = "true";
  }

  this.inventoryService
    .getApprovedRequest(getApprovedReqValue)
    .subscribe((response) => {
      console.log("Approved Request", response);

      const newRecords = response["data"].records;

      if (pageNum === 1) {
        this.approveInv = newRecords;
      } else {
        const existingIds = new Set(this.approveInv.map((item: any) => item.id || item.requestId));
        const uniqueRecords = newRecords.filter((item: any) => !existingIds.has(item.id || item.requestId));

        this.approveInv = [...this.approveInv, ...uniqueRecords];
      }

      this.totalApproved = response["data"].totalCounts;
      this.showInventoryRequest = false;
      this.showApprovedRequest = true;
      this.showPendingRequest = false;
      this.isShimmerLoading = false;
      this.showDeclinedRequest = false;
    });
}



  declineInv = [];
  totalDeclined: any;
  currentDeclinedLimit = 1000
  onFilterDeclinedRequest(
    status: string = "Rejected",
    pageNum = 1,
    limit = this.currentDeclinedLimit,
  ) {
    const field: any = {
      pageNum: pageNum,
      limit: limit,
      status: status,
    };
    this.inventoryService
      .getAllInventoryRequest(field)
      .subscribe((response) => {
        console.log("Approved Request", response);
        // this.declineInv = response["data"].records;
        if (pageNum === 1) {
          this.declineInv = response["data"].records;
        } else {
          this.declineInv = [...this.declineInv, ...response["data"].records];
        }
        this.totalDeclined = response["data"].totalCounts;
        this.showApprovedRequest = false;
        this.showInventoryRequest = false;
        this.showPendingRequest = false;
        this.showDeclinedRequest = true;
      });
  }


    declinedSearchQuery: any;
searchedDeclinedInventory = [];
totalDeclinedSearchedInv: any;

onSearchDeclinedInventory() {
  this.currentPageNume = 1;
  const field: any = {
    pageNum: this.currentPageNume,
    limit: this.totalDeclined,
    searchQuery: this.declinedSearchQuery,
    status: "Rejected",
  };

  if (!this.declinedSearchQuery || this.declinedSearchQuery.trim() === "") {
    this.clearDeclinedSearch();
  } else {
    this.inventoryService
      .getAllInventoryRequest(field)
      .subscribe((response) => {
        console.log("Search Declined Response", response);
        this.searchedDeclinedInventory = response["data"].records;
        this.declineInv = this.searchedDeclinedInventory;
        this.totalDeclinedSearchedInv = response["data"].totalCounts;
        this.totalDeclined = this.totalDeclinedSearchedInv;
      });
  }
}

clearDeclinedSearch() {
  this.declinedSearchQuery = "";
  this.onFilterDeclinedRequest("Rejected", 1, this.currentDeclinedLimit);
}

  // Listing of All Inventory Request
  inventoriesReq = [];
  totalInventoryRequest: any;
  searchInventoryReqQuery: string;
  currentPageNume : number = 1;
  currentLimit: number = 100;
  showActionHeader = false;
getInventoryRequest() {
  console.log("loggged");

  const field: any = {
    pageNum: this.currentPageNume,  
    limit: this.currentLimit,
    searchQuery: this.searchInventoryReqQuery,
  };

  this.inventoryService.getAllInventoryRequest(field).subscribe((response: any) => {
    console.log("Response", response);
    console.log('Fetching Page:', this.currentPageNume, 'Limit:', this.currentLimit);

    const newItems = response.data.records;

    if (this.currentPageNume === 1) {
      this.inventoriesReq = newItems;
    } else {
      const existingIds = new Set(this.inventoriesReq.map((item: any) => item.id));
      const uniqueItems = newItems.filter((item: any) => !existingIds.has(item.id));

      this.inventoriesReq = [...this.inventoriesReq, ...uniqueItems];
    }

    this.showActionHeader = this.inventoriesReq.some(
      req => req.requestedById === this.loggedUserId
    );

    this.totalInventoryRequest = response.data.totalCounts;
    this.showInventoryRequest = true;
    this.showApprovedRequest = false;
    this.showPendingRequest = false;
    this.isShimmerLoading = false;
    this.showDeclinedRequest = false;
  });
}

  
  

searchedInventoryReq: any;
  onSearchInventoryRequest(){
     this.currentPageNume = 1;
        const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalInventoryRequest,
      searchQuery: this.searchInventoryReqQuery,
    };
    if (this.searchInventoryReqQuery === "") {
      this.clearInventoryReqSearch();
    } else {
      this.inventoryService
        .getAllInventoryRequest(field)
        .subscribe((response) => {
          console.log(response);
          this.searchedInventoryReq = response["data"].records;
          this.inventoriesReq = this.searchedInventoryReq;
          this.totalSearchedInv = response["data"].totalCounts;
          this.totalInventoryRequest = this.totalSearchedInv;
        });
    }
  }

    clearInventoryReqSearch(){
    this.searchInventoryReqQuery = "";
    this.searchedInventoryReq ="",
    this.inventoriesReq = [],
    this.currentPageNume = 1,
    this.getInventoryRequest();
  }

  selectedRequestType : any;
  onScroll() {
    console.log("Scrolled! Current Inventory Length:", this.inventoriesReq.length);
   if(this.showInventoryRequest){
    const totalLoaded = this.inventoriesReq.length;
    if (totalLoaded >= this.totalInventoryRequest) return;
    this.currentPageNume++;
    this. getInventoryRequest();
   }
   if (this.showPendingRequest) {
    const totalLoaded = this.pendingReq.length;
    if (totalLoaded >= this.totalPending) return;
    this.currentPageNume++;
    this.onFilterPendingRequest(
      this.selectedRequestType,  
      this.currentPageNume,
      this.currentPendingLimit
    );
  }
  if(this.showApprovedRequest){
    const totalLoaded = this.approveInv.length;
    if (totalLoaded >= this.totalApproved) return;
    this.currentPageNume++;
    this.onFilterApprovedRequest(
      this.selectedRequestType,  
      this.currentPageNume,
      this.currentApprovedLimit
    );
  }
  if(this.showDeclinedRequest){
    const totalLoaded = this.declineInv.length;
    if (totalLoaded >= this.totalDeclined) return;
    this.currentPageNume++;
    this.onFilterDeclinedRequest(
      this.selectedRequestType,  
      this.currentPageNume,      
      this.currentDeclinedLimit          
    );
  }
    }



acceptRequest(requestId: any) {
  const acceptRequest = {
    action: "Accept",
    requestId: requestId,
    requestType: "Inventory Request",
    redirectUrl: `${environment.redirectUrl}#/inventory/inventory-request?filter=Approved Request`,
  };

  this.inventoryService.adminAction(acceptRequest).subscribe({
    next: (response) => {
      console.log("called");
      alertModalWithoutConfirm("success", "Request Accepted");
      // this.snackBar.open("Request Accepted", "OK");
      this.inventoriesReq = this.inventoriesReq.filter(
        req => req.requestId !== requestId
      );
      this.currentPageNume = 1;
      this.getInventoryRequest();
    },
    error: (error) => {
      console.error("API Error:", error);

      const errorMessage =
        error?.error?.message?.message ||
        error?.error?.message ||
        "Something went wrong. Please try again.";

      alertModalWithoutConfirm("error", errorMessage);
    }
  });
}


  async declineRequest(requestId: any) {

    const userConfirmed = await alertModalDecline(
      "Are you sure you want to decline this request?"
    );

    if (userConfirmed) {
     const declineRequest = {
       action: "Rejected",
       requestId: requestId,
       requestType: "Inventory Request",
       redirectUrl: `${environment.redirectUrl}#/inventory/inventory-request?filter=Declined Request`,
     };
   this.inventoryService.adminAction(declineRequest).subscribe((response) => {
     console.log("called");
    //  this.snackBar.open("Request Declined", "OK");
    alertModalWithoutConfirm("success", "Request Declined");
    this.inventoriesReq = this.inventoriesReq.filter(
      req => req.requestId !== requestId
    );
    this.currentPageNume = 1;
     this.getInventoryRequest();
   },
  (err) => {
           console.error("Error while declining the request", err);
           alertModalWithoutConfirm("error", "Failed to decline the request.");
         }
       );
     } else {
       console.log("User cancelled the decline action");
     };
 }

   invLoader = false;
   async deleteInventoryRequest(requestId: any, approverId:any){
     const userConfirmed = await alertModalDelete(
       "Are you sure you want to delete this request?"
     );
     if (userConfirmed) {
      this.invLoader = true;

       const declineRequest = {
        approverId: approverId,
         requestId: requestId,
         requestType: "Inventory Request",
       };
   
       this.inventoryService.deleteAction(declineRequest).subscribe(
         (response) => {
    window.location.reload();
           // this.snackBar.open("Request Declined", "OK");
            setTimeout(() => {
          window.location.reload(); 
        }, 300); 
      
           this.getInventoryRequest();
         },
         (err) => {
           alertModalWithoutConfirm("error", "Failed to delete the request.");
         }
       );
     }
   }

 
}
